import Button from '../Button'
import styles from './styles.module.scss'

export const ThankYouModalContent = ({ onClose, thankYouBody }) => (
    <>
        <p>{thankYouBody}</p>
        <Button type="button" btnStyle="outline" onClick={onClose} className={styles.ratingModalBtn}>
            <T>home.page.nps.modal.close</T>
        </Button>
    </>
)
